import exchangeRate from '@/api/exchange-rate'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  currencies: [],
  branch_id: null
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_CURRENCIES (state, data) {
    state.currencies = data
  },
  SET_BRANCH_ID (state, data) {
    state.branch_id = data
  }
}

export const actions = {
  fetch (context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        all_branch: Array.isArray(context.state.branch_id)
          ? context.state.branch_id.length
            ? undefined
            : true
          : true
      },
      attributes
    )

    return exchangeRate.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  create (context, data) {
    return exchangeRate.store(data)
  },

  async find (context, id) {
    return await exchangeRate.find(id)
  },

  update (context, data) {
    return exchangeRate.update(data)
  },

  delete (context, data) {
    return exchangeRate.destroy(data)
  },

  async dataBeforeCreate (context) {
    if (!context.state.currencies.length > 0) {
      let response = await exchangeRate.currency()
      context.commit('SET_CURRENCIES', response)
    }
  }
}
